import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { filterCategory, toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

const Status = () => {
	const filterData = useSelector((store) => store.filterFieldStore);
	const dispatch = useDispatch();

	const getStatusValue = (status) => {
		if (status.key === 'MINE') return 'MINE';
		else if (status.key === 'SHARED') return 'SHARED';
		else return '';
	};

	const handleCheckbox = (e, status) => {
		let { value, checked, name } = e.target;
		let data = {
			name: 'filterCategory',
			key: getStatusValue(status),
			type: 'FILTER',
			value: value,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	const renderStatusList = () => {
		// if (processName === 'Collection') {
		// 	list = collectionStatusList;
		// }
		return filterCategory.map((status, index) => {
			return (
				<div className="form-group" key={`filter_${index}`}>
					<input
						type="checkbox"
						id={`filter_${index}`}
						name={`filter_${index}`}
						value={status.value}
						onChange={(e) => handleCheckbox(e, status)}
						checked={toggleCheckbox(filterData, 'filterCategory', `filter_${index}`)}
					/>
					<label htmlFor={`filter_${index}`}>
						<span>{status.value}</span>
					</label>
					{/* <div className={`color-box ${status.color}`} /> */}
				</div>
			);
		});
	};

	return (
		<div className="card initial">
			<div className="custom-chekbox">{renderStatusList()}</div>
		</div>
	);
};

export default Status;
